import React from "react";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import PropTypes from "prop-types";
import GonkBox from "views/GonkBox";

export const NotFound = ({descriptor}) =>
    <GonkBox
        id={descriptor.id}
        data-type={descriptor.type}
        data-control-type={descriptor.control}
        data-shortname={descriptor.key}
    >
        <code>formitems/{descriptor.type}/{descriptor.control}.js</code> doesn't
        export a <code>{descriptor.type}{descriptor.control}</code> Component
        (for <code>{descriptor.key}</code>).
    </GonkBox>;

NotFound.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes())
};

export default NotFound;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/NotFound.js